export const createCarouselHeader = (): void => {
    document.querySelectorAll<HTMLElement>('.banner-carousel-video__wrapper').forEach(carousel => {
        const heading: HTMLElement | null = carousel.querySelector('.banner-pool-widget__heading');
        if (!heading) return;
        
        const headerContainer: HTMLDivElement = document.createElement('div');
        headerContainer.classList.add('banner-carousel-video__header');
        
        const link: HTMLAnchorElement = document.createElement('a');
        link.classList.add('banner-carousel-video__link', 'attrax-button-quinary');

        const linkContainer: HTMLDivElement = document.createElement('div');
        linkContainer.classList.add('banner-carousel-video__link-container');
        linkContainer.appendChild(link);
        
        const linkText: string = "{{js.banner-carousel-video__view-all-text}}";
        const linkHref: string = "{{js.banner-carousel-video__view-all-link}}";
        
        link.textContent = linkText;
        link.href = linkHref;
        link.setAttribute('aria-label', linkText);
        
        headerContainer.appendChild(heading);
        carousel.appendChild(linkContainer);
        
        carousel.insertBefore(headerContainer, carousel.firstChild);
    });
};
